import { useSetAtom } from 'jotai/react'
import { useEffect, useMemo } from 'react'

import { ENV_PARAMS } from '@/constants/evnParams'
import { EnableTrade } from '@/constants/trade'
import { writeChainInfosAtom } from '@/stores/trade'

import { useFetch } from './useFetch'

export enum CHAIN_TYPE {
  EVM = 1,
  TRON = 2,
  SOLANA = 3
}

export type BaseChainInfo = {
  cross_ca_addr: string
  from_rpc_url: string
  from_chain_type: CHAIN_TYPE
  from_chain_id: number
  from_chain_name: string
  from_url_logo: string
  to_chain_id: [number, EnableTrade, string, string, CHAIN_TYPE][] // [chainId, EnableTrade, chain_name, url_logo, CHAIN_TYPE]
}

export type FromChain = {
  type: CHAIN_TYPE
  id: number
  name: string
  logo: string
  rpc: string
  bridgeAddress: string
}

export type ToChain = Omit<FromChain, 'rpc' | 'bridgeAddress'> & { enableTrade: boolean }

export type ChainInfo = { fromChain: FromChain; toChains: ToChain[] }

export const useChainInfo = () => {
  const writeChainInfos = useSetAtom(writeChainInfosAtom)

  const { data } = useFetch<{
    sys_status: EnableTrade
    data: BaseChainInfo[]
  }>({
    // url: '/chainInfo'
    url: ENV_PARAMS.MODE === 'prod' ? '/chainInfo' : '/testchainInfo'
  })

  const [enableTrade, chainInfos] = useMemo(() => {
    if (!data || data.code !== 200 || !data.data) return [false, []]

    const { sys_status, data: baseChainInfos } = data.data

    const chainInfos = baseChainInfos.map<ChainInfo>(
      ({
        from_chain_type,
        from_chain_id,
        from_chain_name,
        from_url_logo,
        from_rpc_url,
        cross_ca_addr,
        to_chain_id
      }) => ({
        fromChain: {
          type: from_chain_type,
          rpc: from_rpc_url,
          bridgeAddress: cross_ca_addr,
          id: from_chain_id,
          name: from_chain_name,
          logo: from_url_logo
        },
        toChains: to_chain_id.map(([id, status, name, logo, type]) => ({
          id,
          enableTrade: status === EnableTrade.Enabled,
          name,
          logo,
          type
        }))
      })
    )

    console.log('>>>>>> chainInfos: ', chainInfos)

    return [sys_status === EnableTrade.Enabled, chainInfos]
  }, [data])

  useEffect(() => {
    writeChainInfos(chainInfos)
  }, [chainInfos, writeChainInfos])

  return { enableTrade }
}
